module.exports = __webpack_public_path__ + "img/wechat-pay.2a0ec507.svg";